import { createAsyncThunk } from '@reduxjs/toolkit';

import CATEGORY_API from './category.api';

export const getCategoryAction = createAsyncThunk<any, Category.GetCategoryPayload>(
  'category.getCategory',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await CATEGORY_API.listCategoryAPI(data)
      return res
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

// export const createCategoryAction = createAsyncThunk<any, any>(
//   'create_Category',
//   async ({ data }, { rejectWithValue }) => {
//     try {
//       const res = await CATEGORY_API.createCategoryAPI(data)
//       return res
//     } catch (err: any) {
//       return rejectWithValue(err)
//     }
//   }
// )

// export const updateCategoryAction = createAsyncThunk<any, any>(
//   'update_Category',
//   async ({ data }, { rejectWithValue }) => {
//     try {
//       const res = await CATEGORY_API.updateCategoryAPI(data);
//       return res;
//     } catch (err: any) {
//       return rejectWithValue(err);
//     }
//   },
// );

// export const deleteUser = createAsyncThunk<any, any>(
//   'delete_user',
//   async ({ data }, { rejectWithValue }) => {
//     try {
//       const res = await CATEGORY_API.deleteUserAPI(data);
//       return res;
//     } catch (err: any) {
//       return rejectWithValue(err);
//     }
//   },
// );
